export default class GetMaxAgeRequest {
  businessLine: string
  insuranceType: string
  stayAbroadType?: string

  constructor(data: any) {
    this.businessLine = data.businessLine
    this.insuranceType = data.insuranceType
    this.stayAbroadType = data.stayAbroadType
  }
}
